import styled from 'styled-components'
import { Pill, Tonality } from '@dsny/dsny-component-library'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'
import { Container as ProfileContainer } from '../Profile/Profile.styles'

const mobileQuery = createResponsiveBreakpointQuery('mobileDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileDown
})

const tabletQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.tabletUp
})

const twoColumnQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.reactGridSmallUp
})

export const ConnectedEmailsWrapper = styled.div`
  align-items: center;
  flex-wrap: wrap;
`

export const ConnectedEmailPill = styled(Pill)`
  margin-bottom: 8px;
`

export const Label = styled(Tonality.UIText)`
  font-size: 14px;
`

export const SettingsColumn = styled.div`
  box-sizing: border-box;
  min-height: 1px;
  min-width: 0;
  padding: 0 16px;
`

export const SettingsWideColumn = styled(SettingsColumn)``

export const SettingsRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
  margin-right: -16px;
  margin-left: -16px;
`

export const SettingsGrid = styled.div`
  display: grid;
  gap: 24px;
`

export const SettingsPreferencesRoot = styled(ProfileContainer)`
  @media ${twoColumnQuery} {
    ${SettingsRow} {
      grid-template-columns: repeat(12, minmax(0, 1fr));
    }

    ${SettingsColumn} {
      grid-column: span 4;
    }

    ${SettingsWideColumn} {
      grid-column: span 8;
    }
  }

  @media ${tabletQuery} {
    ${ConnectedEmailsWrapper} {
      display: flex;
      gap: 12px;
    }

    ${ConnectedEmailPill} {
      margin-bottom: 0;
    }
  }

  @media ${mobileQuery} {
    ${Label} {
      margin-bottom: 16px;
    }
  }
`
